var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3478 0H17.2174H6.78257H3.65213C2.78917 0 2.08691 0.702261 2.08691 1.56522V22.4348C2.08691 23.2977 2.78917 24 3.65213 24H20.3478C21.2107 24 21.913 23.2977 21.913 22.4348V1.56522C21.913 0.702261 21.2107 0 20.3478 0ZM7.12742 0.851911H17V2.6087C17 2.8967 16.5863 3.29957 16.2988 3.29957H7.82605C7.53857 3.29957 7.12742 2.89617 7.12742 2.6087V0.851911ZM21 22.4348C21 22.7223 20.6353 23.1021 20.3478 23.1021H3.65213C3.36465 23.1021 3 22.7223 3 22.4348V12V1.56522C3 1.27774 3.36413 1.04348 3.65213 1.04348H6.26083V2.6087C6.26083 3.47165 6.96309 4.17391 7.82605 4.17391H16.1739C17.0368 4.17391 17.9 3.47165 17.9 2.6087V0.851911H20.3478C20.6353 0.851911 21 1.27774 21 1.56522V12V22.4348Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 7.44531H5.73902C5.45102 7.44531 5.21729 7.67905 5.21729 7.96705V13.1844C5.21729 13.4724 5.45102 13.7062 5.73902 13.7062H18.2608C18.5488 13.7062 18.7825 13.4724 18.7825 13.1844V7.96705C18.7825 7.67905 18.5488 7.44531 18.2608 7.44531ZM18 12.8005H6V8.25049H18V12.8005Z",
    fill: "#FF5722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 15.6523H5.73902C5.45102 15.6523 5.21729 15.8315 5.21729 16.0523C5.21729 16.2731 5.45102 16.4523 5.73902 16.4523H18.2608C18.5488 16.4523 18.7825 16.2731 18.7825 16.0523C18.7825 15.8315 18.5488 15.6523 18.2608 15.6523Z",
    fill: "#343434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 18.7832H5.73902C5.45102 18.7832 5.21729 18.9624 5.21729 19.1832C5.21729 19.404 5.45102 19.5832 5.73902 19.5832H18.2608C18.5488 19.5832 18.7825 19.404 18.7825 19.1832C18.7825 18.9624 18.5488 18.7832 18.2608 18.7832Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.63d5b9a7ce321aa844907685409f41b8.svg";
export { ForwardRef as ReactComponent };